import { render, staticRenderFns } from "./EmailAddressForm.vue?vue&type=template&id=fea9b85a&"
import script from "./EmailAddressForm.vue?vue&type=script&lang=js&"
export * from "./EmailAddressForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentVOP/build/VOPWebApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fea9b85a')) {
      api.createRecord('fea9b85a', component.options)
    } else {
      api.reload('fea9b85a', component.options)
    }
    module.hot.accept("./EmailAddressForm.vue?vue&type=template&id=fea9b85a&", function () {
      api.rerender('fea9b85a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/email/EmailAddressForm.vue"
export default component.exports